import { Component, OnInit, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective, AbstractControl } from '@angular/forms';

import { PageService } from '../../../services/page.service';
import { MultiLangPipe } from '../../../pipes/multi-lang.pipe';

@Component({
  selector: 'app-form-datepicker',
  templateUrl: './form-datepicker.component.html',
  styleUrls: ['./form-datepicker.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class FormDatepickerComponent implements OnInit {
  @Input() public config: {
    name: string,
    label?: Array<{languageCode: string, value: string}>,
    displayFormat?: string,
    pickerFormat?: string,
    value?: string | Date,
    min?: string | Date,
    max?: string | Date,
    placeholder?: Array<{languageCode: string, value: string}>,
    required?: boolean,
    pickerOptions?: Object
  };

  constructor(
    private formGroupDir: FormGroupDirective,
    public pageService: PageService
  ) { }

  /**
   * [Getter for control]
   * @author Sachin Jagtap
   * @task QLIKTAG-3238
   */
  public get control(): AbstractControl {
    return this.formGroupDir.form.get(this.config.name);
  }

  ngOnInit() {
  }

  /**
   * [event fired by ion-datetime]
   * @param date [value selected by user]
   * @author Sachin Jagtap
   * @task QLIKTAG-3238
   */
  public onDateChange(date) {
    this.control.setValue(date.detail.value);
  }
}
